import PropTypes from 'prop-types'
import classNames from 'classnames'

import { SENTIMENTS_ICON_HASH } from '@aytm/app/stats/page/components/lib/constants'

import sentimentStyle from '@aytm/app/stats/page/comments/comments/styles/Sentiments.module.scss'

const SentimentIcon = ({
  sentiment = 'None',
  className = null,
  iconClassName = null,
  style = {},
  iconStyle = {},
  ...props
}) => (
  <div
    className={classNames(sentimentStyle[`background-sentiment-${sentiment}`], {
      [className]: Boolean(className)
    })}
    style={style}
    {...props}
  >
    <i
      className={classNames(
        `icon-aytmfd-sentiment-${SENTIMENTS_ICON_HASH[sentiment]}`,
        sentimentStyle[`color-sentiment-${sentiment}`],
        {
          [iconClassName]: Boolean(iconClassName)
        }
      )}
      style={iconStyle}
    />
  </div>
)

SentimentIcon.propTypes = {
  sentiment: PropTypes.string,
  style: PropTypes.object,
  iconStyle: PropTypes.object,
  className: PropTypes.string,
  iconClassName: PropTypes.string
}

export default SentimentIcon
